function localTodayYmd(now = new Date()): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function dateOnly(value: string | null | undefined): string | null {
  if (typeof value !== 'string') return null;
  const match = value.trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
}

export function hasRequestedDateNotPassed(
  fromDate: string | null | undefined,
  toDate: string | null | undefined,
  now = new Date(),
): boolean {
  const start = dateOnly(fromDate);
  if (!start) return false;
  const end = dateOnly(toDate) || start;
  const today = localTodayYmd(now);
  return today <= end;
}

export function isOnRequestedDate(
  fromDate: string | null | undefined,
  toDate: string | null | undefined,
  now = new Date(),
): boolean {
  return hasRequestedDateNotPassed(fromDate, toDate, now);
}

export function resolveRequestCanCancel(options: {
  statusCode: string | null | undefined;
  canCancelFromApi?: boolean;
  fromDate?: string | null;
  toDate?: string | null;
  now?: Date;
}): boolean {
  const status = (options.statusCode || '').toUpperCase();
  if (options.canCancelFromApi === false) {
    return false;
  }
  if (status === 'PENDING') {
    return options.canCancelFromApi !== undefined
      ? options.canCancelFromApi
      : true;
  }
  if (status !== 'APPROVED' || options.canCancelFromApi !== true) {
    return false;
  }
  return hasRequestedDateNotPassed(options.fromDate, options.toDate, options.now);
}

export function canShowApprovedRequestCancel(options: {
  capabilityCanCancel: boolean;
  canAct: boolean;
  statusCode?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  now?: Date;
}): boolean {
  if (!options.capabilityCanCancel || options.canAct) {
    return false;
  }
  if ((options.statusCode || '').toUpperCase() !== 'APPROVED') {
    return false;
  }
  return hasRequestedDateNotPassed(
    options.fromDate,
    options.toDate,
    options.now,
  );
}
